<template>
    <div>
        <v-menu
            v-model="modal"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="textarea"
                    :label="label"
                    :autofocus="autofocus"
                    :readonly="readonly"
                    :disabled="disabled"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    :color="color ? color : inputColor"
                    :background-color="color ? `${color} lighten-5` : inputBackgroundColor"
                    :clearable="!readonly"
                    @click:clear="clear"
                    dense
                    hide-details="auto"
                    @change="save"
                    :rules="rules"
                ></v-text-field>
            </template>
            <v-textarea
                v-model="textarea"
                outlined
                :readonly="readonly"
                :disabled="disabled"
                :color="color ? color : inputColor"
                :background-color="color ? `${color} lighten-4` : inputBackgroundColor"
                dense
                hide-details="auto"
                :rules="rules"
                auto-grow
                @change="save"
            ></v-textarea>
        </v-menu>

        <input type="hidden"/>
    </div>
</template>


<script>
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    props: {
        value: String,
        label: String,
        color: String,
        autofocus: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        rules: Array,
    },
    setup(props, {emit}) {
        const {inputColor, inputBackgroundColor} = useSharedData();

        const textarea = ref(null);
        const modal = ref(false);

        function save() {
            modal.value = false;
            emit("input", textarea.value);
        }

        function clear() {
            textarea.value = null;
            emit("input", null);
        }


        watch(() => props.value, () => {
            if (props.value !== null && props.value !== undefined)
                textarea.value = props.value;
        }, {immediate: true});

        return {
            inputColor,
            inputBackgroundColor,
            textarea,
            modal,
            save,
            clear,
        }
    }
};
</script>